export const EDITING_LOCK_TIMEOUT_MINUTES = 30;

export const EDITING_WARNING_MINUTES = 5;
